/**
 * ConsolidadoDetalhadoReport - All items per count with 21 columns (Excel model)
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

const columns: Column[] = [
  { key: 'codigo_i', label: 'Código I', align: 'center', width: '100px' },
  { key: 'codigo_ii', label: 'Código II', align: 'center', width: '100px' },
  { key: 'hospital_nome', label: 'Hospital', width: '180px' }, // #13: coluna C = nome do hospital
  { key: 'cliente_nome', label: 'Cliente', width: '180px' },
  { key: 'data_contagem', label: 'Data Contagem', format: 'date', width: '120px' },
  { key: 'grupo', label: 'Grupo', width: '160px' },
  { key: 'produto', label: 'Produto', width: '130px' },
  { key: 'descricao', label: 'Descrição', width: '220px' },
  { key: 'preco', label: 'Preço', align: 'right', format: 'decimal', width: '90px' },
  { key: 'valor_sistema', label: '$ Sistema', align: 'right', format: 'decimal', width: '100px' },
  { key: 'valor_contado', label: '$ Contado', align: 'right', format: 'decimal', width: '100px' },
  { key: 'valor_faturar', label: '$ Fatur.', align: 'right', format: 'decimal', width: '100px' },
  { key: 'valor_diferenca', label: '$ Difer.', align: 'right', format: 'decimal', width: '100px' },
  { key: 'lote', label: 'Lote', width: '110px' },
  { key: 'data_validade', label: 'Validade', format: 'date', width: '100px' },
  { key: 'faixa_aging', label: 'Faixa Aging', align: 'center', width: '150px' },
  { key: 'sistema', label: 'Sistema', align: 'right', format: 'decimal', width: '90px' },
  { key: 'contado', label: 'Contado', align: 'right', format: 'decimal', width: '90px' },
  { key: 'sobras', label: 'Sobras', align: 'right', format: 'decimal', width: '90px' },
  { key: 'faltas', label: 'Faltas', align: 'right', format: 'decimal', width: '90px' },
  { key: 'coletado', label: 'Coletado', align: 'right', format: 'decimal', width: '90px' },
  { key: 'faturar', label: 'Faturar', align: 'right', format: 'decimal', width: '90px' },
];

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const ConsolidadoDetalhadoReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <RelatorioGeraisTable
      columns={columns}
      data={data}
      loading={loading}
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      emptyMessage="Nenhum item encontrado no período selecionado."
    />
  );
};
